import { render, staticRenderFns } from "./ManageChange.vue?vue&type=template&id=3a2339e8&scoped=true&"
import script from "./ManageChange.vue?vue&type=script&lang=js&"
export * from "./ManageChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2339e8",
  null
  
)

export default component.exports